import { render, staticRenderFns } from "./AnimalActivityChartView.vue?vue&type=template&id=5a6c3ace&scoped=true&"
import script from "./AnimalActivityChartView.vue?vue&type=script&lang=js&"
export * from "./AnimalActivityChartView.vue?vue&type=script&lang=js&"
import style0 from "./AnimalActivityChartView.vue?vue&type=style&index=0&id=5a6c3ace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6c3ace",
  null
  
)

/* custom blocks */
import block0 from "./AnimalActivityChartView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports